/**
 * CommentHighlightMark — TipTap Mark extension for inline comment highlights.
 *
 * Renders a yellow-highlighted <span> with data-comment-id attribute.
 * Multiple comment marks can overlap on the same text (inclusive: true).
 *
 * See: docs/features/document-system/document-comments.md (Phase 7)
 */
import { Mark, mergeAttributes } from "@tiptap/core";

const CommentHighlightMark = Mark.create({
  name: "commentHighlight",

  // Allow multiple overlapping comment highlights
  inclusive: false,
  excludes: "",

  addAttributes() {
    return {
      commentId: {
        default: null,
        parseHTML: (element) => element.getAttribute("data-comment-id"),
        renderHTML: (attributes) => {
          if (!attributes.commentId) return {};
          return { "data-comment-id": attributes.commentId };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "span[data-comment-id]",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "span",
      mergeAttributes(HTMLAttributes, { class: "comment-highlight" }),
      0,
    ];
  },
});

export default CommentHighlightMark;
